import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { COLORS, PRODUCT, IMG, TEAM_OFFER } from "@/data/site";
import { useCart } from "@/lib/cart";
import { eur } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Shop() {
  const { addItem } = useCart();
  return (
    <div className="bg-ink pt-[70px] md:pt-[84px]">
      <Seo title="Shop" description="STARSOX Grip-Socken in Weiß, Neon Lime und Sunset Orange. Premium-Qualität für 9,99 € – jetzt entdecken." path="/shop" />
      {/* Header */}
      <section className="container-x pt-16 md:pt-24 pb-10">
        <p className="overline mb-4">Kollektion</p>
        <MaskedLines
          start
          className="font-heading uppercase leading-[0.9]"
          lineClassName="text-6xl md:text-8xl"
          lines={["Der Shop"]}
        />
        <p className="mt-6 text-white/50 max-w-xl">
          Eine Socke. Drei Statements. Wähle deine Farbe – jede in Premium-Qualität mit maximalem Grip.
        </p>
      </section>

      {/* Grid */}
      <section className="container-x pb-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COLORS.map((c, i) => (
            <Reveal key={c.key} delay={i * 0.08}>
              <div data-testid={`shop-card-${c.key}`} className="group card-hair overflow-hidden">
                <Link to={`/product?color=${c.key}`} className="block relative aspect-[4/5] overflow-hidden bg-ink">
                  <img src={c.img} alt={`STARSOX ${c.label}`} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute top-4 left-4 h-5 w-5 rounded-full border border-white/60" style={{ backgroundColor: c.hex }} />
                  <span className="absolute top-4 right-4 h-9 w-9 rounded-full bg-white text-ink flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </Link>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-2xl uppercase">{c.label}</h3>
                    <span className="font-heading text-xl">{PRODUCT.price}</span>
                  </div>
                  <p className="text-white/50 text-sm mt-3">{PRODUCT.name} · {PRODUCT.size}</p>
                  <div className="mt-5 flex gap-3">
                    <button onClick={() => addItem(c.key, c.label, 1)} data-testid={`shop-add-${c.key}`} className="btn-primary flex-1 !py-3 !px-5 text-xs">In den Warenkorb</button>
                    <Link to={`/product?color=${c.key}`} className="btn-ghost !py-3 !px-5 text-xs">Details</Link>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Team bundle */}
        <Reveal>
          <div className="mt-8 relative rounded-[2rem] overflow-hidden border border-gold/30 grid lg:grid-cols-2">
            <div className="p-10 md:p-14 flex flex-col justify-center bg-gradient-to-br from-carbon2 to-ink">
              <p className="overline mb-3">Team-Paket</p>
              <h3 className="font-heading text-4xl md:text-6xl uppercase leading-[0.9]">{TEAM_OFFER.pairs} Paar · <span className="text-gold">{TEAM_OFFER.price}</span></h3>
              <p className="mt-4 text-white/60">Statt {TEAM_OFFER.regular} – 10 % Rabatt wird ab 15 Paar automatisch im Warenkorb abgezogen. Ideal für Fußballvereine & Mannschaften.</p>
              <Link to="/teams" data-testid="shop-team-cta" className="btn-primary mt-8 self-start">Jetzt Team bestellen <ArrowRight className="w-4 h-4" /></Link>
            </div>
            <div className="relative min-h-[280px]"><img src={IMG.team} alt="Team" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" /></div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
